import { UtilityMethods } from "@mindmemobile/mm-shared-global";
import { PaymentTransactionStatus } from "../enums";
import { IAPIPaymentGridModel } from "../interfaces";
import { ContactReferenceModel } from "./ContactDetailPageModel";
import { PaymentMethodModel } from "./PaymentMethodModels";

export class PaymentGridModel {
  id: string;
  amount: number;
  status: keyof typeof PaymentTransactionStatus;
  createdDate: Date;
  description: string;
  contact?: ContactReferenceModel;
  paymentMethod?: PaymentMethodModel;
  isRefund: boolean;
  success: boolean;
  constructor(data?: Partial<PaymentGridModel>) {
    this.id = data?.id || "";
    this.amount = data?.amount || 0;
    this.status = data?.status || "Failed";
    this.createdDate = data?.createdDate || new Date();
    this.description = data?.description || "";
    this.contact = data?.contact && new ContactReferenceModel(data.contact);
    this.paymentMethod =
      data?.paymentMethod && new PaymentMethodModel(data.paymentMethod);
    this.isRefund = data?.isRefund || false;
    this.success = data?.success || false;
  }

  static deserializeAPIModel(data: IAPIPaymentGridModel): PaymentGridModel {
    return new PaymentGridModel({
      id: data.id,
      amount: data.amount,
      status: data.status,
      createdDate: UtilityMethods.removeZFromDateString(data.createdDate),
      description: data.description,
      contact:
        data.contactDetails &&
        ContactReferenceModel.deserializeAPIModel(data.contactDetails),
      paymentMethod: PaymentMethodModel.deserializeAPIModel(data.paymentMethod),
      isRefund: data.isRefund,
      success: data.success,
    });
  }
}
